module.exports = __webpack_public_path__ + "img/icon-comment.c0d37c0.svg";